import useEditCharacterSpell from '../composables/useEditCharacterSpell'
//------------------------------
// edit character spells harness
//------------------------------
export default async function useEditCharacterSpellsHarness(changed_spells) {
  console.log('---------------------------------------')
  console.log('IN useEditCharacterSpellsHarness')
  //-------------------------------------------
  // manages all character spell updates (CRUD)
  //-------------------------------------------
  //--------------------------------------
  // create promise for each spell update
  //--------------------------------------
  const promises = changed_spells.map((r) => {
    console.log('IN useEditCharacterSpellsHarness - PROCESSING SPELL:', r)
    //-------------------
    // call api function
    //-------------------
    return useEditCharacterSpell(r)
  })
  //------------------------------------------------------------
  // wait for all updates to complete - let errors propagate up
  //------------------------------------------------------------
  const results = await Promise.all(promises)
  //-----------------------------
  // optionally return responses
  //-----------------------------
  // if (returnResponses) return results
  return results
  //----------------------------------------------
  // else no response (caller awaited completion)
  //----------------------------------------------
  // return
}
